import { RootState } from '../../../app';

export const selectSelectedOption = ({ editorRightSidebar }: RootState) =>
  editorRightSidebar.selectedOption;
